var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',_vm._l((_vm.nodes),function(node,id){return _c('div',{key:id},[_vm._v(_vm._s(id)+" -> links: "+_vm._s(_vm.getEdges(node)))])}),0)}
var staticRenderFns = []

export { render, staticRenderFns }